import {getTaggingData} from "@COMPONENTS/common/tagging/taggingCommon";
import {GlobarBannerText} from "@QUERIES/bff/global/useGlobalBannerText";
import {GlobalMenu, GlobalMenuBff} from "@QUERIES/bff/global/useGlobalMenu";
import {GlobarOpt} from "@QUERIES/bff/global/useGlobalOpt";

/**
 * amplitude - gnb_click
 * @description gnb 공통배너 클릭
 */
export const taggingClickGNB = (menu: GlobalMenu) => {
	try {
		const {menuLv1List, menuLv2List, menuLv3List}: GlobalMenuBff = getTaggingData("useGlobalMenuBFF");
		const globalMenu: GlobalMenu[] = [...menuLv1List, ...menuLv2List, ...menuLv3List];

		const {lv, dspOrder, dspMenu, dspNm} = menu;
		const defaultData = {
			selectDiv: lv === 0 ? 3 : lv?.toString(), // lv "1" | "2" | "3"
			menuSeq: dspOrder || 999,
		};

		const findMenu = (sid: string) => globalMenu.find(v => v.dspSid === sid);
		// LV1
		if (lv === 1) return {...defaultData, dspMenuCd: dspMenu || "-", dspMenuNm: dspNm || "-"};
		// LV2
		if (lv === 2) {
			const lv1 = findMenu(menu.dspSidHi);
			return {
				...defaultData,
				dspMenuCd: lv1.dspMenu || "-", // lv1
				dspMenuNm: lv1.dspNm || "-", // lv1
				subDspMenuCd: dspMenu, // lv2
				subDspMenuNm: dspNm, // lv2
			};
		}
		if (lv === 3) {
			const isLocal = lv === 3 && menu.locTypeCd !== "T";
			const isThema = lv === 3 && menu.locTypeCd === "T";
			const lv3 = menu;
			const lv2 = findMenu(menu.dspSidHi);
			const lv1 = findMenu(lv2.dspSidHi);

			const defaultLv3Data = {
				...defaultData,
				dspMenuCd: lv1?.dspMenu || "-", // lv1
				dspMenuNm: lv1?.dspNm || "-", // lv1
				subDspMenuCd: lv2?.dspMenu, // lv2
				subDspMenuNm: lv2?.dspNm, // lv2
			};
			// LV3
			if (isLocal) return {...defaultLv3Data, dspSidCd: lv3.dspMenu || "-", menuNm: lv3.dspNm || "-"};
			// LV3 - 테마
			if (isThema) return {...defaultLv3Data, themeCd: lv3.dspNm || "-", themeNm: lv3.dspNm || "-"};
		}

		// LV3 - 프로모션
		const isPromotion = menu.subDspTypeCd === "PMO";
		if (isPromotion) {
			const lv3 = menu;
			const lv2ForPromo = findMenu(menu.dspSid);
			const lv1ForPromo = findMenu(lv2ForPromo?.dspSidHi);
			return {
				...defaultData,
				dspMenuCd: lv1ForPromo?.dspMenu || "-", // lv1
				dspMenuNm: lv1ForPromo?.dspNm || "-", // lv1
				subDspMenuCd: lv2ForPromo?.dspMenu, // lv2
				subDspMenuNm: lv2ForPromo?.dspNm, // lv2
				promoNm: lv3.subDspNm || "-", // lv3
				promoPcUrl: lv3.dspUrl || "-", // lv3
				promoMoUrl: lv3.dspUrl || "-", // lv3
			};
		}
	} catch (error) {
		console.log(error);
		return null;
	}
};

/**
 * amplitude - pkg_select_icon_main
 * @description GNB 퀵 아이콘 클릭(PC 우측 상단)
 */
export const taggingClickGNBIcon = (option: GlobarOpt) => {
	try {
		return {
			iconSeq: option.menuOrder.toString() || "-",
			pcUrl: option.pcMenuUrl || "-",
			moUrl: option.mobileMenuUrl || "-",
			menuNm_Pc: option.pcMenuNm || "-",
			menuNm_Mo: option.mobileMenuNm || "-",
		};
	} catch (error) {
		return null;
	}
};

/**
 * amplitude - pkg_search_keyword
 * @description GNB 검색바 돋보기 버튼
 */
export const taggingClickGNBSearch = (bannerText: GlobarBannerText) => {
	try {
		return {
			selectDiv: "searchBar",
			keyword: bannerText.keyword || "-",
			pcUrl: bannerText.pcUrl || "-",
			moUrl: bannerText.mobileUrl || "-",
			displayStartDt: bannerText.startDt || "-",
			displayEndDt: bannerText.endDt || "-",
		};
	} catch (error) {
		return null;
	}
};
